import React from 'react';
export function PainSection() {
  const painPoints = ['Hay apagones en tu zona y no sabes cuánto tiempo pueden durar — ni qué harías si duran días', 'Tu despensa dura 2 días como máximo. Si el supermercado cierra, tu familia pasa hambre', 'Sabes que algo puede pasar en cualquier momento pero no tienes un plan concreto', 'Vivís en un apartamento y creés que la supervivencia "no es para vos" porque no tenés jardín ni sótano', 'Tus hijos dependen de vos y eso te genera una ansiedad que no logras quitarte de encima', 'Mirás las noticias y sentís que el mundo está un paso del caos, pero no sabés por dónde empezar'];
  return <section className="bg-gradient-to-b from-[#0a0a0a] to-[#111111] py-12 px-5" data-id="element-139">
      <div className="max-w-[900px] mx-auto" data-id="element-140">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold text-center mb-8 leading-[1.2]" data-id="element-141">
          ¿Te identificas con{' '}
          <span className="text-brand-orange" data-id="element-142">
            alguna de estas situaciones?
          </span>
        </h2>

        <ul className="max-w-[700px] mx-auto space-y-3" data-id="element-143">
          {painPoints.map((point, index) => <li key={index} className="bg-gradient-to-br from-[#1a1a1a] to-[#222222] border-l-4 border-brand-orange p-4 md:p-5 rounded-r-lg text-sm md:text-base leading-[1.6] flex items-start gap-3" data-id="element-144">
              <span className="text-lg shrink-0" data-id="element-145">⚠️</span>
              <span data-id="element-146">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}